import React, { useState } from "react";
import styled from "styled-components";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { isObjectStateEmpty } from "../../../utils";

const InputBar = ({ handleSubmit, permissions }) => {
  const [inputStates, setInputStates] = useState({
    driver_id: "",
    fleet_coach_id: "",
  });

  const handleChange = (key, val) => {
    const values = { ...inputStates };
    values[key] = val;
    setInputStates(values);
  };

  const handleFormSubmit = () => {
    handleSubmit(inputStates);
  };

  const checkIfButtonDisabled = () => {
    return isObjectStateEmpty(inputStates);
  };

  return (
    <AssetsInputBar className="flex items-center justify-end">
      <Input
        value={inputStates["driver_id"]}
        data-testid="driverId"
        id="sushi-input"
        onChange={(e) => handleChange("driver_id", e)}
        label="Driver ID"
      />
      <span className="bold mr-10">OR</span>
      <Input
        value={inputStates["fleet_coach_id"]}
        id="sushi-input"
        data-testid="phone-no"
        onChange={(e) => handleChange("fleet_coach_id", e)}
        label="Fleet Coach ID"
      />
      <Button
        data-testid="submitButton"
        className="sushi-btn mb-10"
        onClick={handleFormSubmit}
        disabled={checkIfButtonDisabled()}
      >
        Apply
      </Button>
    </AssetsInputBar>
  );
};

const AssetsInputBar = styled.div`
  // max-width: 530px;
  margin-right: 0;
  margin-left: auto;
  margin-bottom: 40px;
  #sushi-input {
    margin-bottom: unset;
  }
  #sushi-input > div {
    display: none;
  }
`;

export default InputBar;
